module.exports = __webpack_public_path__ + "img/toilet.0c2dd09e.svg";